<template lang="pug">
Page.repair-edit
    .repair-edit__top(
        slot="header"
    )
        h1.repair-edit__title
            | Ремонт под ключ

        SvMenu(
            @copy="copy"
            @remove="remove"
        )

    SvTabs.repair-edit__table(
        :tabs="['Основное']"
        :current="0"
    )
        .repair-edit__actions
            SvButton.repair-edit__action(
                view="secondary"
                text="Отмена"
                :prependIcon=`{
                    icon: 'cancel',
                    width: 24,
                    height: 24,
                    hover: '#1993EB',
                    default: '#B7BAC6'
                }`
                @click="resetForm"
            )

            SvButton.repair-edit__action(
                view="secondary"
                text="Применить"
                :prependIcon=`{
                    icon: 'refresh',
                    width: 24,
                    height: 24,
                    hover: '#1993EB',
                    default: '#B7BAC6'
                }`
                @click="save(false)"
            )

            SvButton.repair-edit__action(
                view="primary"
                text="Сохранить"
                :prependIcon=`{
                    icon: 'check',
                    width: 24,
                    height: 24,
                    default: '#1993EB',
                    hover: '#1993EB'
                }`
                @click="save(true)"
            )

    .repair-edit__form
        .repair-edit__form-item
            span.repair-edit__form-title
                | Активность

            .repair-edit__form-elements--small.radio
                SvRadio.repair-edit__form-radio(
                    v-model="is_active"
                    :value="true"
                    label="Да"
                )

                SvRadio.repair-edit__form-radio(
                    v-model="is_active"
                    :value="false"
                    label="Нет"
                )



        .repair-edit__form-item
            span.repair-edit__form-title
                | Жилые комплексы
            .repair-edit__form-elements--small
                SvSelectList(
                    v-model="residential_complexes"
                    :withSearch="true"
                    :items="getResidentialsComplexes"
                )

        .repair-edit__form-item
            span.repair-edit__form-title
                | Заголовок

            .repair-edit__form-elements--small
                SvInput(
                    v-model="title"
                    color="graylight"
                    placeholder="Например: люкс"
                    :withIcon="false"
                )


        .repair-edit__form-item
            span.repair-edit__form-title
                | Стоимость за м2 в руб.

            .repair-edit__form-elements--small
                SvInput(
                  v-model="price"
                  mask="numeric"
                  color="graylight"
                  placeholder="Например: 10000"
                  :withIcon="false"
                )

        .repair-edit__form-item
            span.repair-edit__form-title
                | Описание

            .repair-edit__form-elements--medium
              SvTextarea(
                v-model="description"
                placeholder="Например: люкс"
                :rows="4"
              )
              //- ckeditor(
              //-   v-model="description"
              //-   :editor="editor"
              //-   :config="editorConfig"
              //- )

        .repair-edit__form-item
            span.repair-edit__form-title
                | Фото ремонта

            .repair-edit__form-elements--large
              MultiLoad(
                @uploaded="uploaded"
              )

              .gallery__photoes(
                v-if="current.gallery.length"
              )
                .photo-item-wrapper(
                    v-for="(photo, index) in current.gallery"
                    :key="Math.random()"
                  )
                  PhotoBlockLight(
                    :value="current.gallery[index]"
                    @input="obj => changePhoto(obj, index)"
                    @remove="removePhoto(index)"
                  )
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import SvRadio from '@/components/uikit/SvRadio.vue';
import SvMenu from '@/components/uikit/SvMenu.vue';
import Page from '@/layouts/page.vue';
import SvInput from '@/components/uikit/SvInput.vue';
import SvButton from '@/components/uikit/SvButton.vue';
import SvTabs from '@/components/uikit/SvTabs.vue';
import SvUpload from '@/components/uikit/SvUpload.vue';
import SvSelectList from '@/components/uikit/SvSelectList.vue';
import { rusToLatin } from '@/helpers/transform';
import '@ckeditor/ckeditor5-build-classic/build/translations/ru';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import MultiLoad from '@/components/forms/subforms/MultiLoad.vue';
import PhotoBlockLight from '@/components/forms/subforms/PhotoBlockLight.vue';
import SvTextarea from '@/components/uikit/SvTextarea.vue';

export default {
  name: 'RepairEdit',

  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {
        ckfinder: {
          // Upload the images to the server using the CKFinder QuickUpload command.
          // uploadUrl: '/admin/developers/' + this.$route.params.id + '/upload-inline-image',

          // Define the CKFinder configuration (if necessary).
          // options: {
          //   resourceType: 'Images',
          //   pass: 5,
          // },
        },
        toolbar: {
          viewportTopOffset: 0,
        },
        language: 'ru',
      },
    }
  },

  beforeMount() {
    this.$store.dispatch('repair/getById', this.$route.params.id);
    if(this.$route.params.id === 'new') {
      this.$store.dispatch('repair/getListResidentials');
    }
  },

  beforeRouteUpdate(to, from, next) {
    if (to.params.id !== 'new') {
      this.$store.dispatch('repair/getById', to.params.id);
    }
    next();
  },
  mounted() {
  },

  computed: {
    ...mapGetters({
      current: 'repair/getCurrent',
      getResidentialsComplexes: 'repair/getResidentialsComplexes',
      getValuesResidentialsComplexes: 'repair/getValuesResidentialsComplexes'
    }),

    is_active: {
      get() {
        // Обертка Boolean, т.к. с севера приходит 1 или 0
        return Boolean(this.current.is_active);
      },
      set(is_active) {
        this.setValue({ is_active });
      },
    },

    residential_complexes: {
      get() { return this.getValuesResidentialsComplexes; },
      set(residential_complexes) { this.setValue({ residential_complexes }); },
    },

    price: {
      get() {
        return this.current.price;
      },
      set(price) {
        this.setValue({ price });
      },
    },

    description: {
      get() {
        return this.current.description;
      },
      set(description) {
        this.setValue({ description });
      },
    },



    title: {
      get() {
        return this.current.title;
      },
      set(title) {
        this.setValue({ title });
      },
    },

    alias: {
      get() {
        return this.current.alias;
      },

      set(alias) {
        this.setValue({ alias });
      },
    },

    logo: {
      get() {
        return this.current.logo;
      },

      set(logo) {
        this.setValue({ logo });
      },
    },
  },

  methods: {
    ...mapMutations({
      setValue: 'repair/setValue',
      // addImage: 'repair/addImage',
    }),

    resetForm() {
      this.$store.commit('repair/clearCurrent');
      this.$router.push({ name: 'repairs' });
    },

    copy() {
      this.$store.commit('repair/setCurrent', this.$route.params.id);
      this.setValue({ id: null });
      this.$router.push({ name: 'repair-edit', params: { id: 'new' } });
    },

    async remove() {
      await this.$store.dispatch('repair/remove', this.$route.params.id);
      this.$router.push({ name: 'repairs' });
    },

    async save(isRedirect = false) {
      const data = await this.$store.dispatch('repair/save');
      let id = typeof data === 'number' ? data : (data.data && data.data.id);
      console.log("save -> data", data)
      console.log("save -> id", id)
      if (!isRedirect) {
        this.$router.push({
          name: 'repair-edit',
          params: {
            id,
          },
        }).catch(err => {});
      } else {
        this.resetForm();
      }
    },

    uploaded(files) {
      files.forEach((image) => {
        const gallery = this.current.gallery.slice();
        gallery.push({image});
        this.setValue({gallery})


        // this.addImage({image})
      });
    },

    changePhoto(obj, index){

      const gallery = this.current.gallery.slice();
      gallery.splice(index, 1, obj);
      this.setValue( {gallery} );



    },

    removePhoto(index) {
      const gallery = this.current.gallery.slice();
      gallery.splice(index, 1);
      this.setValue( {gallery} );

    }
  },

  components: {
    Page,
    SvInput,
    SvButton,
    SvTabs,
    SvMenu,
    SvRadio,
    SvUpload,
    SvSelectList,
    MultiLoad,
    PhotoBlockLight,
    SvTextarea
  },
};
</script>

<style lang="scss" scoped>
.repair-edit__title {
    margin: 10px 0 19px 0;
    font-size: 46px;
    font-weight: 500;
    color: #404450;
}

.repair-edit__form-title {
    display: flex;
    justify-content: flex-end;
    margin-right: 49px;
    align-items: center;
}

.repair-edit__form-item {
    display: grid;
    grid-template-columns: 291px 1fr;
    margin-top: 26px;
}

.repair-edit__top {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.repair-edit__form-elements--small {
    width: 311px;

    &.radio {
        display: flex;
    }
}

.repair-edit__form {
    padding: 50px 0;
}

.repair-edit__form-radio {
    margin-right: 21px;
}

.repair-edit__form-elements--medium {
    width: 495px;
}

.repair-edit__actions {
    display: flex;
    align-items: center;
    height: 100%;
}

.repair-edit__search {
    width: 47%;
    min-width: 280px;
}
.gallery__photoes {
  display: flex;
  flex-wrap: wrap;
  margin: 10px -10px;
}
.photo-item-wrapper {
  padding: 10px;
}
</style>
